import endpoint from './endpoint';
import client from '../../common/client';

export default client(endpoint);